<template>
  <div class="content">
    <div class="search-box">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" size="small">
        <el-form-item label="订单编号" label-width="100px" prop="serialNumber">
          <el-input
            style="width: 240px"
            clearable
            v-model="searchFrom.serialNumber"
            placeholder="请输入订单编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" label-width="100px" prop="messageStatus">
          <el-select
            clearable
            v-model="searchFrom.messageStatus"
            placeholder="请选择状态"
            style="width: 240px"
          >
            <el-option
              v-for="item in messageOpations"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间" label-width="100px" prop="refundState">
          <el-date-picker
            style="width:400px"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="placeChange"
            v-model="searchFrom.placeReceiptTime"
            type="datetimerange"
            range-separator="至"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            style="margin-left: 100px"
            type="primary"
            icon="el-icon-search"
            @click="search"
            >搜索</el-button
          >
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- -----------------------表格区域 --------------------------------->
    <div class="content-table">
      <el-table
        :data="tableData"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        style="width: 100%"
        border
      >
        <el-table-column type="index" label="序号"> </el-table-column>
        <el-table-column prop="title" label="标题" width="auto">
          <template slot-scope="scope">
            <div>
              {{ scope.row.title }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="serialNumber" label="订单编号" width="auto">
        </el-table-column>
        <el-table-column prop="isPubGoods" label="订单类型" width="auto">
          <template slot-scope="scope">
            <div>
              {{ isPubGoodsEnums[scope.row.isPubGoods] || "--" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="messageStatus" label="状态" width="auto">
          <template slot-scope="scope">
            <div>
              {{ messageEnums[scope.row.messageStatus] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="时间" width="auto">
        </el-table-column>
        <el-table-column label="操作" width="auto">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="toOrderDetails(scope.row)"
              >查看</el-button
            >
            <el-button v-if="scope.row.messageStatus == '1'" type="text" size="small" @click="deleteData(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[5, 10, 20, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="消息通知"
      :visible.sync="dialogVisible"
      width="1280"
      :before-close="handleClose"
    >
      <div>
        <el-descriptions>
          <el-descriptions-item label="标题">
            {{ exaimRow.title }}
          </el-descriptions-item>
          <el-descriptions-item label="订单编号">
            {{ exaimRow.serialNumber }}
          </el-descriptions-item>
          <el-descriptions-item label="订单类型">
            {{ isPubGoodsEnums[exaimRow.isPubGoods] || "--" }}
          </el-descriptions-item>
        </el-descriptions>
        <el-divider></el-divider>
        <el-timeline :reverse="reverse">
            <el-timeline-item>
                        <el-card>
                            <h4>时间:{{exaimRow?.createTime}}</h4>
                            <p>
                                <span>
                                     新地址:
                                </span>
                                {{exaimRow?.newAddr}}
                            </p>
                        </el-card>
            </el-timeline-item>
              <el-timeline-item>
                        <el-card>
                            <p>
                                <span>
                                    旧地址:
                                </span>
                                {{exaimRow?.oldAddr}}
                            </p>
                        </el-card>
            </el-timeline-item>
        </el-timeline>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      exaimRow: {},
      messageEnums: {
        1: "已读",
        0: "未读",
      },
      isPubGoodsEnums: {
        0: "普通商品(现金和自建)",
        1: "积分商品",
        2: "厂商进货单",
        3: "秒杀订单",
        4: "代下单",
        5: "直播礼物",
        6: "直销订单",
      },
      messageOpations: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "已读",
          value: "1",
        },
        {
          label: "未读",
          value: "0",
        },
      ],
      dialogVisible: false,
      searchFrom: {
        createEndTime: null,
        createStartTime: null,
        messageStatus: '',
        serialNumber: null,
        placeReceiptTime: [],
      }, // 搜索条件
      // 表格数据
      tableData: [],
      loading: false,
      // 条数
      pageSize: 10,
      // 当前页
      pageNum: 1,
      // 总条数
      total: 0,
      currentId: null,
      reverse: false,
    };
  },
  components: {},
  computed: {
    activities() {
      const { exaimRow } = this;
      return [
        {
          content: exaimRow?.newAddr,
          timestamp: exaimRow?.createTime,
        },
        {
          content: exaimRow?.oldAddr,
          timestamp: "",
        },
      ];
    },
  },
  created() {
    this.getOrderList();
  },
  methods: {
    ...mapActions(['updateNoticeNums']),
    handleClose() {
      this.dialogVisible = false;
    },
    toOrderDetails(row) {
      this.exaimRow = row;
      if(row.messageStatus == '0'){
          this.$api.notice
          .updateNotice({
            id: row.id,
          })
          .then((res) => {
            if (res.success) {
               row.messageStatus = '1'
               this.updateNoticeNums();//更新菜单未读数量
            }
          });
      }
      this.dialogVisible = true;
    },
    resetForm() {
      this.searchFrom = {
        createEndTime: null,
        createStartTime: null,
        messageStatus: '',
        serialNumber: null,
        placeReceiptTime: [],
      };
      this.getOrderList();
    },
    // 搜索
    search() {
      this.getOrderList();
    },
    // 弹窗显示 审核
    deleteData(row) {
      console.log(row);
      this.$confirm("确认删除消息吗，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.notice
          .deleteNotice({
            id: row.id,
          })
          .then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.getOrderList();
            }
          });
      });
    },
    getOrderList() {
      let resData = {
        pageSize: this.pageSize,
        pageNo: this.pageNum,
        ...this.searchFrom,
      };
      delete resData.placeReceiptTime;
      this.loading = true;
      this.$api.notice.queryNOticelist(resData).then((res) => {
        this.loading = false;
        if (!res.success) {
          this.tableData = [];
          this.total = 0;
          return;
        }
        this.tableData = this.$decryptData(res.data).list;
        this.total = parseInt(this.$decryptData(res.data).total);
      });
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.getOrderList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getOrderList();
    },

    placeChange(value) {
      if (!value) {
        [this.searchFrom.createStartTime, this.searchFrom.createEndTime] = [
          null,
          null,
        ];
        return;
      }
      this.searchFrom.createStartTime = value[0];
      this.searchFrom.createEndTime = value[1];
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  .pagination-box {
    padding: 8px 0;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
